

export const outboxesStateModel = [
    {
        state: "Undefined",
        stateString: "Indefinido",
        
    },
    {
        state: "Pending",
        stateString: "Pendiente",

    },
    {
        state: "Sent",
        stateString: "Enviado",
     
    },
    {
        state: "Error",
        stateString: "Error",
   
    },
    {
        state: "Quarantine",
        stateString: "Cuarentena",
    },
    {
        state: "PendingResend",
        stateString: "Pendiente de envio",
   
    },
    {
        state: "Resent",
        stateString: "",
   
    },
    {
        state: "Cancelled",
        stateString: "Cancelado",
   
    },
    {
        state: "Sending",
        stateString: "Enviando",
   
    }
]